import { createIcon } from '@chakra-ui/icons'

const TSIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g transform="translate(5311 -4734.065)">
      <path
        d="M-5242.5 4817.5h-59c-2.5 0-4.5-2-4.5-4.5v-71c0-2.5 2-4.5 4.5-4.5h44.4l19.1 17.3v58.2c0 2.5-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M-5242.5 4817c2.2 0 4-1.8 4-4v-58l-18.8-17h-44.2c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5v-71c0-2.8 2.2-5 5-5h44.6l19.4 17.6v58.4c0 2.8-2.3 5-5 5z"
        fill="#E1E4EA"
      />
      <path
        d="M-5237.5 4767h-69v-25c0-2.8 2.2-5 5-5h45.6l18.4 17.5v12.5z"
        fill="#A3A64F"
      />
      <path
        d="M-5255.8 4737.1v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0l-18.2-17.4z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(-5299.533 4756.032)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        TS
      </text>
      <path
        fill="#E1E4EB"
        d="M-5288 4806.5c0 .4.3.7.7.7h30.8c.4 0 .7-.3.7-.7V4789c0-.4-.3-.7-.7-.7h-25.7l24.5-8.1c.3-.1.5-.5.4-.8l-1.9-5.7c-.1-.3-.5-.5-.8-.4l-29.3 9.7c-.3.1-.5.5-.4.8l1.7 5.2v17.5zm30.9-16.9v16.2h-29.5v-16l.5-.2h29zm-12.5-6.8-3.3 1.1.3-5.1 3.3-1.1-.3 5.1zm1.6-5.5 3.3-1.1-.3 5.1-3.3 1.1.3-5.1zm-6.3 7-3.3 1.1.3-5.1 3.3-1.1-.3 5.1zm-4.7 1.6-3.3 1.1.3-5.1 3.3-1.1-.3 5.1zm20.3-6.7-4.8 1.6.3-5.1 3.1-1 1.4 4.5zm-24.7 3.2-.3 5.1-2.7.9h-.4l-1.4-4.4 4.8-1.6z"
      />
      <path
        fill="#E1E4EB"
        d="M-5275 4801.9c.2.1.5.1.7 0l5.9-4.2c.3-.2.4-.6.2-.9 0-.1-.1-.1-.2-.2l-5.9-4.2c-.3-.2-.7-.1-.9.2-.1.1-.1.2-.1.4v8.3c0 .3.1.5.3.6zm1-7.6 4.1 2.9-4.1 2.9v-5.8z"
      />
    </g>
  ),
})

export default TSIcon
